import React from "react";
import moment from "moment";

export default function Info({ device }) {
  if (!device) return null;

  const renderStatus = () => {
    if (device.status === "not available") {
      return (
        <div className="flex gap-2 items-center justify-center w-full">
          <div className="w-2 h-2 rounded-full bg-green-400" />
          <div className="text-xs tracking-wider text-green-400">{device.status}</div>
        </div>
      );
    } else if (device.status === "available") {
      return (
        <div className="flex gap-2 items-center justify-center w-full">
          <div className="w-2 h-2 rounded-full bg-red-400" />
          <div className="text-xs tracking-wider text-red-400">{device.status}</div>
        </div>
      );
    } else if (device.status === "lost") {
      return (
        <div className="flex gap-2 items-center justify-center w-full">
          <div className="w-2 h-2 rounded-full bg-red-400" />
          <div className="text-xs tracking-wider text-red-400">{device.status}</div>
        </div>
      );
    }
  };

  return (
    <div className="bg-white rounded-md shadow-lg p-6">
      <div className="flex justify-center mb-6">
        <img src={"https://support.apple.com/library/APPLE/APPLECARE_ALLGEOS/SP825/macbookair.png"} alt="mac-logo" className="w-32" />
      </div>
      <div className="mb-6">
        <div className="w-full text-lg text-center font-bold text-gray-800 mb-2">{device.name || device.model}</div>
        <div>{renderStatus()}</div>
      </div>
      <div className="flex flex-col items-center">
        <div className="flex items-center gap-4 w-full">
          <span className="text-sm flex-1 text-right text-gray-600">Model</span>
          <span className="text-sm flex-1 text-left text-gray-800">{device.model}</span>
        </div>
        <div className="flex items-center gap-4 w-full">
          <span className="text-sm flex-1 text-right text-gray-600">Serial Number</span>
          <span className="text-sm flex-1 text-left text-gray-800">{device.serial_number}</span>
        </div>
        <div className="flex items-center gap-4 w-full">
          <span className="text-sm flex-1 text-right text-gray-600">RAM</span>
          <span className="text-sm flex-1 text-left text-gray-800">{device.ram}</span>
        </div>
        <div className="flex items-center gap-4 w-full">
          <span className="text-sm flex-1 text-right text-gray-600">Storage</span>
          <span className="text-sm flex-1 text-left text-gray-800">{device.storage}</span>
        </div>
        <div className="flex items-center gap-4 w-full">
          <span className="text-sm flex-1 text-right text-gray-600">Keyboard layout</span>
          <span className="text-sm flex-1 text-left text-gray-800">{device.keyboard_layout}</span>
        </div>
        {device.status === "not available" ? (
          <div className="flex items-center gap-4 w-full">
            <span className="text-sm flex-1 text-right text-gray-600">User</span>
            <span className="text-sm flex-1 text-left text-gray-800">{device.userName}</span>
          </div>
        ) : (
          <div className="flex items-center gap-4 w-full">
            <span className="text-sm flex-1 text-right text-gray-600">Office</span>
            <span className="text-sm flex-1 text-left text-gray-800">{device.office}</span>
          </div>
        )}
      </div>
      {device.comments ? (
        <>
          <div className="my-5 border-b border-gray-400 w-1/3 mx-auto" />
          <div className="flex items-center gap-4 w-full">
            <span className="text-sm flex-1 text-right text-gray-600">Comments</span>
            <span className="text-sm flex-1 text-left text-gray-800">{device.comments}</span>
          </div>
        </>
      ) : null}
      <div className="flex flex-col items-center">
        <div className="flex items-center gap-4 w-full">
          <span className="text-xs flex-1 text-right text-gray-500">Updated at</span>
          <span className="text-xs flex-1 text-left text-gray-500">{moment(device.updatedAt).format("DD/MM/YYYY, HH:mm")}</span>
        </div>
        <div className="flex items-center gap-4 w-full">
          <span className="text-xs flex-1 text-right text-gray-500">Created at</span>
          <span className="text-xs flex-1 text-left text-gray-500">{moment(device.createdAt).format("DD/MM/YYYY, HH:mm")}</span>
        </div>
      </div>
    </div>
  );
}
